import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section1 .mySwiper", {
    spaceBetween: 6,
    slidesPerView: 5,

});
var swiper2 = new Swiper(".section1 .mySwiper2", {
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
    },
    thumbs: {
        swiper: swiper,
    },
});
